import React from 'react';
import { Icon } from '@mui/material';
import MDBox from 'src/components/md/MDBox';
import MDTypography from 'src/components/md/MDTypography';

interface EmptyStateProps {
  icon?: string;
  title?: string;
  message?: string;
  height?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon = 'info',
  title = 'No Data Available',
  message = 'There is currently no data to display for this metric.',
  height = '300px',
}) => {
  return (
    <MDBox
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height={height}
      p={3}
    >
      <Icon sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }}>{icon}</Icon>
      <MDTypography variant="h6" color="text" mb={1}>
        {title}
      </MDTypography>
      <MDTypography
        variant="body2"
        color="text"
        textAlign="center"
        maxWidth="300px"
      >
        {message}
      </MDTypography>
    </MDBox>
  );
};

export default EmptyState;
